// LivWizeGuy store bridge: wires the black site's buttons to the Shopify store.
// app.js (the design export's runtime) re-renders the page from its template on every click; it calls
// LWGX_afterRender after each render, so prices and button states are re-applied here every time.
(function () {
  var X = window.LWGX || { products: {}, files: {}, cartCount: 0 };
  var P = X.products;
  var page = window.LWGX_PAGE || "";

  var money = function (cents) { return X.prefix + (cents % 100 ? (cents / 100).toFixed(2) : String(cents / 100)); };
  // The first variant in stock, else the first variant (so a sold-out product reads "Sold out", not "Coming soon").
  var firstAvailable = function (p) { if (!p || !p.variants.length) return null; for (var i = 0; i < p.variants.length; i++) if (p.variants[i].available) return p.variants[i]; return p.variants[0]; };
  var variantTitled = function (p, test) { if (!p) return null; for (var i = 0; i < p.variants.length; i++) if (test(p.variants[i].title)) return p.variants[i]; return null; };
  var line = function (v) { return v ? { id: v.id, quantity: 1, price: v.price, available: v.available } : null; };

  // The Skin Towel picker (order matches the design's list). Every pick is one towel with its Skin included, at the
  // Skin Towel's price: matchups with a full-towel kit sell the kit, Clemson Tiger sells the Tiger Towel, and every
  // other Skin is a Skin Towel variant ("Accessory" option) named after it.
  var SWAG = "the-livwizeguy-swag-towel";
  var withSkin = function (accessory) { return function () { return [line(variantTitled(P[SWAG], function (t) { return t.split(" / ").pop() === accessory; }))]; }; };
  var SKIN_TOWEL = {
    "Chicago vs Green Bay": function () { return [line(firstAvailable(P["the-chicago-vs-green-bay-towel"]))]; },
    "Chicago vs Philadelphia": function () { return [line(firstAvailable(P["chicago-vs-philadelphia-towel"]))]; },
    "Chicago vs New York": function () { return [line(firstAvailable(P["the-chicago-vs-new-york-towel"]))]; },
    "Clemson Tiger": function () { return [line(firstAvailable(P["tiger-towel-skins"]))]; },
    "USA Flag": function () { return [line(variantTitled(P[SWAG], function (t) { return /US Flag/i.test(t); }))]; },
    "Purple Prowl": withSkin("Purple Prowl Skin"),
    "Green Bay": withSkin("Green Bay Skin"),
    "Frozen Tundra": withSkin("Frozen Tundra Skin"),
    "Chicago vs Atlanta": withSkin("Chicago vs Atlanta Skin"),
    "Chicago vs New England": withSkin("Chicago vs New England Skin"),
    "Chicago vs Seattle": withSkin("Chicago vs Seattle Skin"),
    "Chicago vs Detroit": withSkin("Chicago vs Detroit Skin"),
    "Chicago vs New Orleans": withSkin("Chicago vs New Orleans Skin"),
    "Chicago vs Tampa Bay": withSkin("Chicago vs Tampa Bay Skin"),
    "Bear Down": withSkin("Bear Down Skin"),
    "Chicago vs Detroit (Lions Don't Roar)": withSkin("Chicago vs Detroit Skin – Lions Don't Roar in Chicago"),
    "Chicago vs Green Bay (Cheese Melts)": withSkin("Chicago vs Green Bay Skin – Cheese Melts in Chicago"),
    "Chicago vs Buffalo": withSkin("Chicago vs Buffalo Skin"),
    "Chicago vs Miami": withSkin("Chicago vs Miami Skin"),
    "Chicago vs Jacksonville": withSkin("Chicago vs Jacksonville Skin"),
  };
  var PICKS = ["Chicago vs Green Bay", "Chicago vs Philadelphia", "Chicago vs New York", "Clemson Tiger", "Purple Prowl", "Green Bay", "Frozen Tundra", "USA Flag", "Chicago vs Atlanta", "Chicago vs New England", "Chicago vs Seattle", "Chicago vs Detroit", "Chicago vs New Orleans", "Chicago vs Tampa Bay", "Bear Down", "Chicago vs Detroit (Lions Don't Roar)", "Chicago vs Green Bay (Cheese Melts)", "Chicago vs Buffalo", "Chicago vs Miami", "Chicago vs Jacksonville"];
  // A pick shows only while what it sells is still in the store: archived kits and Skins are hidden from the picker
  // instead of rendering as "Coming soon", and the page opens on the first pick that sells (see LWGX_afterRender).
  var pickExists = function (name) { var f = SKIN_TOWEL[name]; var ls = f ? f() : null; return !!ls && ls.length > 0 && ls.every(Boolean); };
  window.LWGX_hidePick = function (name) { return !pickExists(name); };
  window.LWGX_firstPick = Math.max(0, PICKS.findIndex(pickExists));
  var pickIndex = function () { var i = state().skinPick; return i == null ? window.LWGX_firstPick : i; };
  // The Skins page cards, by the name in each card's image description ("<name> Skins: …").
  var SKINS = {
    "Chicago vs Green Bay": "chicago-vs-green",
    "Chicago vs Philadelphia": "chicago-vs-philadelphia-skin",
    "Chicago vs New York": "chicago-game-day-skin",
    "Chicago vs Atlanta": "chicago-vs-atlanta-skin",
    "Chicago vs New England": "chicago-vs-new-england-skin",
    "Chicago vs Seattle": "chicago-vs-seattle-skin",
    "Chicago vs Detroit": "chicago-vs-detroit-skin",
    "Chicago vs New Orleans": "chicago-vs-new-orleans-skin",
    "Chicago vs Tampa Bay": "chicago-vs-tampa-bay-skin",
    "Bear Down": "bear-down-skin",
    "Chicago vs Detroit (Lions Don't Roar)": "chicago-vs-detroit-lions-skin",
    "Chicago vs Green Bay (Cheese Melts)": "chicago-vs-green-bay-cheese-melts-skin",
    "Chicago vs Buffalo": "chicago-vs-buffalo-skin",
    "Chicago vs Miami": "chicago-vs-miami-skin",
    "Chicago vs Jacksonville": "chicago-vs-jacksonville-skin",
  };
  var HAT = { 1: /^Black$/i, 2: /^White$/i, 3: /Royal Blue/i, 4: /Orange/i };

  function state() { return (window.DCComp && window.DCComp.state) || {}; }
  function cardName(btn) {
    for (var el = btn; el && el !== document.body; el = el.parentElement) {
      var img = el.querySelector && el.querySelector('img[alt*=" Skins:"]');
      if (img) return img.getAttribute("alt").split(" Skins:")[0];
    }
    return "";
  }
  // What a buy button puts in the cart: a list of lines (all must be available), or null when it isn't sold.
  function linesFor(btn) {
    // Cards built from the catalog (Shop page, Skins grid) name their variant, so they add exactly what they show.
    var vid = btn.getAttribute && btn.getAttribute("data-lwgx-variant");
    if (vid) return [{ id: Number(vid), quantity: 1, price: Number(btn.getAttribute("data-lwgx-variant-price")) || 0, available: !btn.hasAttribute("data-lwgx-soldout") }];
    if (page === "towel") return [line(firstAvailable(P[X.current]))];
    if (page === "hat") { var c = state().gHat || 1; return [line(variantTitled(P[X.current], function (t) { return HAT[c].test(t); }))]; }
    if (page === "skin-towel") { var f = SKIN_TOWEL[PICKS[pickIndex()]]; return f ? f() : null; }
    if (page === "skins") { var h = SKINS[cardName(btn)]; return h ? [line(firstAvailable(P[h]))] : null; }
    if (X.current && P[X.current]) return [line(firstAvailable(P[X.current]))];
    return null;
  }
  var sellable = function (ls) { return !!ls && ls.length > 0 && ls.every(function (l) { return l && l.available; }); };
  var total = function (ls) { return ls.reduce(function (s, l) { return s + (l ? l.price : 0); }, 0); };

  var pickDefaulted = false;
  window.LWGX_afterRender = function (root) {
    if (page === "skin-towel") {
      // Open on the first pick that sells (the design opens on index 0, now an archived kit), then hide dead picks.
      if (state().skinPick == null && !pickDefaulted && window.DCComp) { pickDefaulted = true; window.DCComp.setState({ skinPick: window.LWGX_firstPick, gSkin: 0 }); }
      root.querySelectorAll("button[aria-pressed]").forEach(function (b) { var n = b.textContent.trim(); if (PICKS.indexOf(n) > -1) b.hidden = window.LWGX_hidePick(n); });
    }
    root.querySelectorAll("[data-cart-count]").forEach(function (el) { el.textContent = X.cartCount; });
    root.querySelectorAll("[data-lwgx-add]").forEach(function (btn) {
      var ls = linesFor(btn);
      var ok = sellable(ls);
      btn.disabled = !ok;
      btn.textContent = ok ? "Add to cart" : (ls && ls.every(Boolean) ? "Sold out" : "Coming soon");
      btn.classList.toggle("lwgx-off", !ok);
      // The price shown next to this button follows what it would actually add.
      var scope = page === "skins" ? btn.parentElement : root;
      var price = scope && scope.querySelector("[data-lwgx-price]");
      if (price) price.textContent = ls && ls.every(Boolean) ? money(total(ls)) : "—";
    });
  };

  // Toast
  var toast = document.createElement("div"); toast.className = "lwgx-toast"; toast.setAttribute("role", "status"); document.body.appendChild(toast);
  var tt;
  function say(msg, cartLink) {
    toast.innerHTML = "<span></span>" + (cartLink ? '<a href="' + X.routes.cart + '">View cart</a>' : "");
    toast.firstChild.textContent = msg;
    toast.classList.add("is-on"); clearTimeout(tt); tt = setTimeout(function () { toast.classList.remove("is-on"); }, 4200);
  }
  function rerender() {
    if (window.DCComp) window.DCComp.setState({});
    else document.querySelectorAll("[data-cart-count]").forEach(function (el) { el.textContent = X.cartCount; });
  }

  document.addEventListener("click", function (e) {
    var btn = e.target.closest && e.target.closest("[data-lwgx-add]");
    if (btn) {
      e.preventDefault();
      var ls = linesFor(btn);
      if (!sellable(ls)) return;
      var label = btn.textContent; btn.disabled = true; btn.textContent = "Adding…";
      fetch(X.routes.cartAdd, {
        method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: ls.map(function (l) { return { id: l.id, quantity: 1 }; }) }),
      }).then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message); }); })
        .then(function () { return fetch(X.routes.cartJs, { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); }); })
        .then(function (c) { X.cartCount = c.item_count; say("Added to cart", true); })
        .catch(function (err) { say(err && err.message ? err.message : "Couldn't add that to your cart."); })
        .then(function () { btn.disabled = false; btn.textContent = label; rerender(); });
      return;
    }
    var join = e.target.closest && e.target.closest("[data-lwgx-join]");
    if (join) {
      e.preventDefault();
      var input = join.parentElement.querySelector('input[type="email"]');
      var email = input ? input.value.trim() : "";
      if (!/^\S+@\S+\.\S+$/.test(email)) { say("Enter a valid email address."); if (input) input.focus(); return; }
      post({ form_type: "customer", "contact[email]": email, "contact[tags]": "newsletter" }, "You're on the list. Watch your inbox for the next drop.", function () { if (input) input.value = ""; });
      return;
    }
    var inq = e.target.closest && e.target.closest("[data-lwgx-inquiry]");
    if (inq) {
      e.preventDefault();
      var v = function (id) { var el = document.getElementById(id); return el ? el.value.trim() : ""; };
      if (!v("co-name") || !/^\S+@\S+\.\S+$/.test(v("co-email")) || !v("co-details")) { say("Add your name, a valid email and the details."); return; }
      post({
        form_type: "contact", "contact[subject]": "Custom order inquiry", "contact[name]": v("co-name"), "contact[email]": v("co-email"),
        "contact[organization]": v("co-org"), "contact[quantity]": v("co-qty"), "contact[body]": v("co-details"),
      }, "Thanks. We'll be in touch about design, pricing and timing.", function () {
        ["co-name", "co-email", "co-org", "co-qty", "co-details"].forEach(function (id) { var el = document.getElementById(id); if (el) el.value = ""; });
      });
    }
  });

  // Posts a Shopify customer/contact form. If Shopify answers with a spam check, the real form is submitted so the visitor can pass it.
  function post(fields, okMsg, done) {
    var fd = new FormData(); fd.append("utf8", "✓");
    Object.keys(fields).forEach(function (k) { fd.append(k, fields[k]); });
    fetch(X.routes.contact, { method: "POST", body: fd, credentials: "same-origin" }).then(function (r) {
      if (/posted=true/.test(r.url)) { say(okMsg); done(); return; }
      var f = document.createElement("form"); f.method = "post"; f.action = X.routes.contact; f.style.display = "none";
      fd.forEach(function (val, key) { var i = document.createElement("input"); i.type = "hidden"; i.name = key; i.value = val; f.appendChild(i); });
      document.body.appendChild(f); f.submit();
    }).catch(function () { say("Something went wrong. Please try again."); });
  }

  // Store pages without the design runtime (cart, search…) still need the count painted once.
  if (!document.getElementById("dc-template")) rerender();
})();
